module.exports = __webpack_public_path__ + "fonts/dsiccc2020930.87f86beb.woff2";